import { Utils } from "../Utils";
import { GridAktiviteter } from "./GridAktiviteter";

export class PlanTab {
    plan: any;
    planId: string;

    constructor(plan) {
        this.plan = plan;
        this.planId = "Plan_" + plan.id;
             
        Utils.addNewTab(this.planId, "sitemap", plan.navn);
        $("#" + this.planId).html("<div class='plan-name'>" + plan.navn + "</div><div id='For" + this.planId + "'/>");

        //var container = $("#" + this.planId);
        //let extra = Utils.isIE() ? 115 : 105;
        //var th = $(".navbar").height() + $("#menuForm").height() + $(".nav-tabs").height() + extra;
        //let newHeight = window.innerHeight - th;
        //let rows = Math.round(newHeight / 30) - 2;
        //$(container).height(newHeight);
        new GridAktiviteter($("#For" + this.planId), {data: plan});

        //$("#" + this.planId).html('<h1>Kuka</h1>');
    }
}


// WEBPACK FOOTER //
// ./TS/Plan/PlanTab.ts